(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function initGalleryVideos(root) {
    root.querySelectorAll('[data-nc-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ncVideosReady) return;
      var main = gallery.querySelector('[data-nc-gallery-main]');
      var image = main && main.querySelector('img');
      if (!main || !image || !gallery.querySelector('[data-nc-video-thumb]')) return;
      gallery.dataset.ncVideosReady = 'true';
      var activeVideo = null;
      var activeButton = null;
      var buttons = gallery.querySelectorAll('[data-nc-thumb], [data-nc-video-thumb]');
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
      });
      gallery.addEventListener('click', function (event) {
        var button = event.target.closest('[data-nc-thumb], [data-nc-video-thumb]');
        if (!button || !gallery.contains(button)) return;
        var isVideo = button.hasAttribute('data-nc-video-thumb');
        if (isVideo && button === activeButton && activeVideo) return;
        var nextVideo = null;
        if (isVideo) {
          var template = button.querySelector('template[data-nc-gallery-video]');
          if (!template) return;
          var fragment = template.content.cloneNode(true);
          nextVideo = fragment.querySelector('video');
          if (!nextVideo) return;
        }
        if (activeVideo) {
          activeVideo.pause();
          activeVideo.remove();
          activeVideo = null;
        }
        image.hidden = isVideo;
        main.classList.toggle('is-video', isVideo);
        buttons.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        activeButton = button;
        if (nextVideo) {
          main.appendChild(nextVideo);
          activeVideo = nextVideo;
          var play = nextVideo.play();
          if (play && play.catch) play.catch(function () {});
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGalleryVideos(document); });
  } else {
    initGalleryVideos(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initGalleryVideos(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
